var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebj4audsva",
    d: "M0.75 0.311L17.096 0.311 17.096 20.7 0.75 20.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M17.405 15.825h-.295V3.699l.163.08c.04.02.086.032.132.032.112 0 .213-.063.263-.161.035-.07.041-.15.017-.224-.024-.074-.077-.135-.147-.17l-.558-.275-.05-.026L11.047.033c-.082-.044-.181-.044-.265 0L4.9 2.955l-.05.026-.558.275c-.132.08-.18.247-.11.384.069.136.233.197.376.138L4.72 3.7v7.902l-.088-.086c-.115-.111-.3-.11-.413.003-.113.114-.115.296-.003.412l.22.22-.484.448-.206-.205c-.116-.112-.3-.11-.414.004-.114.112-.116.296-.004.41l.19.19-.48.45-.175-.174c-.116-.11-.3-.11-.414.004-.114.112-.115.296-.004.41l.161.16-.483.449-.144-.143c-.116-.112-.3-.11-.414.003-.113.113-.115.295-.004.41l.13.13-.483.448-.115-.113c-.115-.11-.3-.109-.413.003-.113.114-.115.297-.003.412l.099.098-.304.28H.295c-.163 0-.295.132-.295.293 0 .162.132.294.295.294h17.11c.163 0 .295-.132.295-.294 0-.16-.132-.292-.295-.292zM4.721 13.48v2.345H1.338l3.383-3.136v.791zm2.36 2.345h7.67v-2.051H7.08v2.05z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(8.1 1.8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2j6dt1qi9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebj4audsva"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M16.134 2.87v-.01h.962c0-.388-.23-.739-.586-.896l-.378-.167-.301-.7c-.205-.476-.677-.786-1.2-.786h-.95c-.204 0-.341.209-.26.395l.107.242.024.059c-.753.174-1.377.73-1.616 1.488l-1.05 3.312c-.233.733-.85 1.283-1.608 1.433l-2.135.424L2.516 2.4l-.401.589C1.225 4.294.75 5.833.75 7.409c0 1.928.693 3.794 1.953 5.262l.603.702v1.434l3.848 3.026.549 2.23h.002l-.642.638h3.527l-.64-.638H8.48l-.567-2.291 4.073-2.142c1.7-.894 3.04-2.336 3.8-4.09.802-1.85.887-3.928.24-5.836l-.671-2.048c.43-.007.78-.357.78-.786",
    mask: "url(#2j6dt1qi9b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M23.074 3.755c0 .18-.146.325-.326.325-.18 0-.327-.146-.327-.325 0-.179.147-.324.327-.324.18 0 .326.145.326.324",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirds);
export default __webpack_public_path__ + "static/media/birds.6c8ff566b57fbbdad44da2c083df69a8.svg";
export { ForwardRef as ReactComponent };